import React from 'react';
import AcceptHostedIframe from './AcceptHostedIframe';

/**
 * Deployment instructions
 *
 * Go to Magento Admin:
 *     - Stores > Configuration > Sales > Payment Methods
 *     - Find "Authorize.net CIM" section
 *     - Change Payment Form Type to "Accept Hosted iframe -- PCI SAQ A -- most secure"
 *     - In the same section, set "Hosted Communicator URL" to:
 *       https://localhost:3000/authnetcim/hosted/communicator
 *     - Save Config
 *
 *     - Sales -> Checkout -> ParadoxLabs Payment Module Settings -> Security Settings -> Enable public API = Yes
 *
 * Also you need to rewrite vendor/paradoxlabs/authnetcim/Model/Api/GraphQL/Hosted/GetPaymentParams.php:85 (allow guest usage of this controller)
 */


const AuthorizeNetForm = ({
  tokenbaseConfig = null,
  cartData = null,
  onTransactionComplete = null,
  onTransactionError = null,
  guestEmail = null
}) => {
  const handleIframeTransactionComplete = (result) => {
    if (onTransactionComplete) {
      onTransactionComplete(result);
    }
  };

  const handleIframeTransactionError = (error) => {
    console.error('Iframe transaction error:', error);
    if (onTransactionError) {
      onTransactionError(error);
    }
  };

  const handleIframeCancel = () => {
    console.log('Payment cancelled by user');
  };

  return (
    <div className="authorizenet-form">
      <h4 className="card-form-title">Secure Credit Card Payment</h4>

      <AcceptHostedIframe
        tokenbaseConfig={tokenbaseConfig}
        cartData={cartData}
        customerInfo={{ email: guestEmail }}
        onTransactionComplete={handleIframeTransactionComplete}
        onTransactionError={handleIframeTransactionError}
        onCancel={handleIframeCancel}
        isVisible={true}
      />
    </div>
  );
};

export default AuthorizeNetForm;